import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TolerancePositionTypes } from 'src/utils/enums/rotor-type.enum';

@Injectable()
export class ImageRendererService {
  public t1Highlight$ = new BehaviorSubject<boolean>(false);
  public t2Highlight$ = new BehaviorSubject<boolean>(false);
  public cgHighlight$ = new BehaviorSubject<boolean>(false);
  public hasHighlight$ = new BehaviorSubject<boolean>(false);

  public onElementHighlightChange(
    element: TolerancePositionTypes | string,
    highlight: boolean
  ): void {
    this.t1Highlight$.next(element === TolerancePositionTypes.t1 ? highlight : false);
    this.t2Highlight$.next(element === TolerancePositionTypes.t2 ? highlight : false);
    this.cgHighlight$.next(element === TolerancePositionTypes.cg ? highlight : false);
    this.hasHighlight$.next(highlight);
  }
}
